import React, { useState } from "react";
import { useFormikContext } from "formik";
import BillingTypeFormInput from "./BillingTypeFormInput";
import InboundBillingTypeSelectionModal from "../Billing/InboundBillingTypeSelectionModal";
import { extractBillingTypes } from "../../../../../utils/billingHelpers";

export default function BillingTypeFormField({ name, label, shipment }) {
  const [open, setOpen] = useState(false);
  const { setFieldValue, values } = useFormikContext();

  const handleToggle = () => {
    setOpen(v => !v);
  };

  const handleSelect = billingType => {
    // Just update the form field value, don't save to backend yet
    // It will be saved when the user clicks "Next" (form submit)
    const selectedType = billingType === "I'm not sure" ? "TBD" : billingType;
    setFieldValue(name, selectedType);
    handleToggle();
  };

  const getInboundBillingTypes = () => {
    const inboundBilling = shipment?.project?.billingTypes?.inbound;
    return extractBillingTypes(inboundBilling, shipment?.project?.billingType);
  };

  const { types, comments } = getInboundBillingTypes();

  return (
    <>
      <BillingTypeFormInput 
        name={name} 
        label={label} 
        value={values[name]} 
        onClick={handleToggle} 
      />
      {open && (
        <InboundBillingTypeSelectionModal
          open={true}
          onClose={handleToggle}
          billingTypes={types}
          billingComments={comments}
          onSelect={handleSelect}
          selectedBillingType={values[name]}
          onBack={null}
        />
      )}
    </>
  );
}
